<template>
  <div
    :style="`text-align: ${
      center ? 'center' : 'left'
    }; font-size: ${fontSize}; font-weight: ${fontWeight}`"
  >
    {{ titleUperCase }}
    <div v-if="subtitle">
      <span style="font-size: 16px">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTitle',
  props: {
    title: { type: String, default: '' },
    center: { type: Boolean, default: false },
    fontSize: { type: String, default: '27px' },
    fontWeight: { type: Number, default: 500 },
    subtitle: { type: String, default: '' },
  },
  computed: {
    titleUperCase() {
      return this.title.toUpperCase();
    },
  },
};
</script>

<style></style>
